import React, { useEffect, useState } from "react";
import PayConfBar from "../layout/PayConfirmDetailBar";
import LoadingOverlay from "react-loading-overlay";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import { components } from "react-select";
import DropdownIcon from "../../assets/images/faq/btn/down_arrow.svg";
import { customStyles } from "./GolfCourses";
import { getCourseHoles, addCourseForLoggedInUser } from "../../services/apiService";
import HttpService from "../../services/HttpService";
import { getApiErrorMsg, formatPrice } from "../../utils/helper";
import { DateManager, DateManagerAddYear } from "../Reusable/TimeDateManager";
import { BASE_URL } from "../../config.json";
import ENUMS from "../../utils/ENUMS.js";

const token = localStorage.getItem(ENUMS.AUTH);
const role = (localStorage.getItem("userRole") || "").toLowerCase();
const isSuperAdmin = role === "superadmin";
const clubId = localStorage.getItem("selected_club_id");

export const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <img style={{ marginLeft: "0.5rem", width: "3rem" }} src={DropdownIcon} />
  </components.DropdownIndicator>
);

const Modal = ({ show, close, title, children }) => {
  return show ? (
    <div className="modalContainerasfdfasdfasdfasd" onClick={close}>
      <div className="modalasdfasdfasdfasdfasdf" onClick={(e) => e.stopPropagation()} style={{ backgroundColor: "white", zIndex: 100 }}>
        <header className="modal_header">
          <h2 className="modal_header-title">
            {title}
            <button className="close" onClick={close} style={{ fontSize: "26px" }}>
              ✕
            </button>
          </h2>
        </header>
        <main className="modal_content">{children}</main>
      </div>
    </div>
  ) : null;
};

const PayCourses = () => {
  const history = useHistory();

  const [courseName, setCourseName] = useState("");
  const [courseNameError, setCourseNameError] = useState(false);

  const [totalNumHoles, setTotalNumHoles] = useState(null);
  const [holesError, setHolesError] = useState(false);

  const [agreeTC, setAgreeTC] = useState(false);
  const [agreeTCError, setAgreeTCError] = useState(false);

  const [holes, setHoles] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [modal, setModal] = useState(false);
  const [termsText, setTermsText] = useState("");

  const [billingDetailsLoading, setBillingDetailsLoading] = useState(!isSuperAdmin);
  const [billingDetails, setBillingDetails] = useState(null);

  useEffect(() => {
    const fetchHoles = async () => {
      try {
        const res = await getCourseHoles();
        setHoles(res.data.data);
      } catch {
        toast.error("Failed to load holes");
      }
    };
    fetchHoles();
  }, []);

  useEffect(() => {
    if (!isSuperAdmin) {
      const fetchBillingDetails = async () => {
        try {
          const res = await HttpService.get('/club/course/new/subscription/');
          setBillingDetails(res.data.data);
        } catch (err) {
          toast.error(getApiErrorMsg(err) || "Unable to get billing details");
        } finally {
          setBillingDetailsLoading(false);
        }
      };
      fetchBillingDetails();
    }
  }, []);

  const handleTermsModal = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/terms_condition/`);
      setTermsText(res.data.data[0].description);
      setModal(true);
    } catch {
      toast.error("Failed to load terms");
    }
  };

  const validateForm = () => {
    let isValid = true;
    if (!courseName.trim()) {
      setCourseNameError(true);
      isValid = false;
    } else {
      setCourseNameError(false);
    }

    if (!totalNumHoles) {
      setHolesError(true);
      isValid = false;
    } else {
      setHolesError(false);
    }

    if (!agreeTC) {
      setAgreeTCError(true);
      isValid = false;
    } else {
      setAgreeTCError(false);
    }

    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = {
      course_name: courseName,
      total_num_holes: totalNumHoles,
      agreeTC: agreeTC,
    };

    try {
      setSpinner(true);
      let res;
      if (isSuperAdmin) {
        const clubId = localStorage.getItem("selected_club_id");

        const payload = { ...formData, golfclub_id: clubId };
        console.log(clubId,"clubID");
        
        res = await axios.post(`${BASE_URL}/club/admin-create-course/`, payload,);
      } else {
        res = await addCourseForLoggedInUser(token, formData);
      }

      if (res.status === 200 && res.data.errMsg == null) {
        toast.success("Course added successfully!");

      if(isSuperAdmin){
 history.push("/club-course-list");
      }  else{ history.push("/loged-user-courses");}
       
      
      } else {
        toast.error("Something went wrong!");
      }
    } catch {
      toast.error("something went wrong!");
    } finally {
      setSpinner(false);
    }
  };

  return (
    <LoadingOverlay active={spinner} spinner text="Adding your course...">
      <div className="paycourses">
        <ToastContainer />
        <div className="paycourses__wrap">
          <div className="paycourses__box">
            <PayConfBar />
            <form onSubmit={handleSubmit}>
              <div className="paycourses__box__sec">
                <div className="paycourses__box__sec__cadd">
                  <input
                    type="text"
                    placeholder="Course Name"
                    value={courseName}
                    onChange={(e) => setCourseName(e.target.value)}
                    className="form__input-md"
                  />
                  {courseNameError && <div style={{ color: "red", paddingLeft: "2rem" }}>* Required!</div>}
                </div>

                <div className="custom-select-wrapper">
                  <CreatableSelect
                    options={holes.map((hole) => ({
                      label: hole.total_holes,
                      value: hole.total_holes,
                    }))}
                    onChange={(e) => setTotalNumHoles(e?.value || null)}
                    value={totalNumHoles ? { label: totalNumHoles, value: totalNumHoles } : null}
                    components={{ DropdownIndicator }}
                    styles={customStyles()}
                    placeholder="Select No Of Holes*"
                    isClearable={false}
                    isSearchable={false}
                  />
                  {holesError && <div style={{ color: "red", paddingLeft: "2rem" }}>* Please select valid Hole</div>}
                </div>
              </div>

         <div className="paycourses__box__sec_term">
                <div style={{ padding: "1rem" }} className="paycourses__box__sec__cadd">
                  {!billingDetailsLoading && billingDetails ? (
                    <div className="cpay__box__right__count-add-course">
                      <span className="text-ops-b-16">
                        {billingDetails.plan.interval === "year" ? (
                          <>
                            Your Timely Subscription expires on {DateManager(billingDetails.period_end)}. This new course
                            will be added on a pro-rata basis from today until your renewal date. The cost charged to your
                            existing card will be {formatPrice(billingDetails.amount)}, which includes VAT.
                          </>
                        ) : (
                          <>
                            Your Timely Subscription expires on {DateManagerAddYear(billingDetails.period_end)}. This new
                            course will be added on a pro-rata basis from today until your renewal date. The additional
                            monthly cost will be {formatPrice(billingDetails.amount)}, making your total monthly payment{" "}
                            {formatPrice(billingDetails.subscription_combined.amount)}. These costs include VAT.
                          </>
                        )}
                      </span>
                    </div>
                  ) : (
                    <div>
                      <h2 className="text-jost-sb-20">Note:</h2>
                      <ol style={{ padding: "0 1.5rem" }}>
                        <li>Any course addition will be charged immediately on a pro-rata basis.</li>
                      </ol>
                    </div>
                  )}

                  <div className="cpay__box__right-check" style={{ marginTop: "1rem" }}>
                    <input
                      type="checkbox"
                      id="check_pay"
                      checked={agreeTC}
                      onChange={(e) => setAgreeTC(e.target.checked)}
                    />
                    <label htmlFor="check_pay" className={`checkbox ${agreeTC}-checked`}></label>
                    <span className="text-ops-rg-15-cap">
                      I Agree To Timely Golf’s&nbsp;
                      <a
                        href="#"
                        className="text-ops-rg-15-cap"
                        onClick={(e) => {
                          e.preventDefault();
                          handleTermsModal();
                        }}
                      >
                        Terms & Conditions
                      </a>
                    </span>
                    {agreeTCError && <div style={{ color: "red" }}>You have not agreed to T&C.</div>}
                  </div>

                  <Modal show={modal} close={() => setModal(false)} title="TERMS FOR Timely Golf">
                    <div dangerouslySetInnerHTML={{ __html: termsText }} />
                  </Modal>
                </div>
              </div>


              <div className="paycourses-links">
                <a
                  onClick={() => history.push("/loged-user-courses")}
                  className="paycourses-links-back link-md-gray"
                  style={{ cursor: "pointer" }}
                >
                  Back to courses
                </a>
                <button className="res-btn-primary" type="submit" disabled={billingDetailsLoading && !isSuperAdmin}>
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default PayCourses;
